/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import GlobalLoader from 'jpaas-component/utils/globalLoader.js'
// import { consoleDwtl } from "@/utils/console";
// consoleDwtl();
// 公司富文本编辑器
Vue.prototype.$GlobalLoader = GlobalLoader
Vue.prototype.baseUrl = "/"
Vue.prototype.$BASE_URL = "/"


import "./registerServiceWorker"; //
// import "lib-flexible"; // 移动屏幕适配
import "./assets/common.css"; // 全局重置样式
import "swiper/css/swiper.css";
// import './utils/flexible.js'
// import "../node_modules/hanweb-ui/dist/hg-vcomponents.min.css"; //
// 集成rsa加解密
// import JSEncrypt from "jsencrypt";
// 引入swiper
// import "swiper/dist/css/swiper.css";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

Vue.use(Antd);

// 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false;

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (from.name == "confirm") {
    to.meta.isBack = true;
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
/* eslint-disable */
